export default {
  labels: {
    sold_out: 'Épuisé !',
    most_popular: '#{{rank}} Plus populaire',
    last_ordered: 'Dernière commande',
  },
};
